"use client";

import React from "react";
import Link from "next/link";
import { Button } from "./ui/Button";
import { Sparkles } from "lucide-react";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full bg-paper/90 backdrop-blur-md border-b border-line/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between">
        {/* Wordmark */}
        <Link href="/" className="flex items-center gap-2.5 group">
          <span className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-ink group-hover:text-clay transition-colors">
            Curated Den
          </span>
          <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-clay" />
          <span className="hidden sm:inline-block text-xs uppercase tracking-widest text-ink-soft font-medium">
            Interiors
          </span>
        </Link>

        {/* Navigation links */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-ink-soft">

          <Link href="/#how-it-works" className="hover:text-ink transition-colors">
            How it works
          </Link>
          <Link href="/#styles" className="hover:text-ink transition-colors">
            Styles
          </Link>
          <Link href="/#consult" className="hover:text-ink transition-colors">
            Designer Consult
          </Link>
        </nav>

        {/* Action Button */}
        <div className="flex items-center gap-3">
          <Link href="/design">
            <Button size="md" className="gap-1.5">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Design my room</span>
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
